import classNames from "classnames";
import { useRef } from "react";
import { useTranslation } from "next-i18next";
import { useTruncatedElement } from "@talladega/hooks";

type Props = {
  text: string;
  lines?: "2" | "3";
};

export const LabelClamp = ({ text, lines = "3" }: Props) => {
  const { t } = useTranslation(["common"]);
  const ref = useRef(null);
  const { isTruncated, isShowingMore, toggleIsShowingMore } =
    useTruncatedElement(ref);

  return (
    <>
      <span
        className={classNames("break-words", {
          "line-clamp-2": !isShowingMore && lines === "2",
          "line-clamp-3": !isShowingMore && lines === "3",
        })}
        ref={ref}
      >
        {text}
      </span>
      {isTruncated && (
        <button
          className="text-primary-500 px-1 text-sm font-semibold underline"
          type="button"
          onClick={toggleIsShowingMore}
        >
          {isShowingMore ? t("common:show_less") : t("common:show_more")}
        </button>
      )}
    </>
  );
};
